import React from 'react';
import { Route } from 'react-router';

import VerifyDob from '../../components/Pages/VerifyDob/VerifyDobForm';


const routes = <Route path="verifydob" component={VerifyDob} />;

export default routes;



// WEBPACK FOOTER //
// ./src/routes/www/verifydob.js